import { useTranslation } from "react-i18next"
import Product from "../../../models/Product"
import { connect } from "react-redux"
import { FormEvent, useMemo, useState } from "react"
import { entityTextField } from "../../Utils/EntityField"
import { Stack } from "@mui/material"
import { IconProgressButton } from "../../Utils/ProgressButton"
import { SearchOutlined } from '@mui/icons-material';
import { AppState } from "../../../reducers"
import { SessionState } from "../../../reducers/auth/session"
import { useHistory, useLocation } from "react-router-dom"
import { filtersToSearch } from "../../Utils/Filters/Filter"

interface Props {
  session: SessionState
}

const emptyProduct: Product = {
  id: null,
  code: '',
  description: '',
  information: '',
  brandId: 0,
  brandName: '',
  sectionId: 0,
  sectionName: '',
  groupId: 0,
  groupName: '',
  subgroupId: 0,
  subgroupName: '',
  measurementId: 0,
  measurementName: '',
  order: 0,
  ownerId: 0,
  ownerName: '',
  status: '',
  updated: '',
  price: 0,
  package: 0,
  money: '',
  discounts: null
}

const PreorderProductCodeForm: React.FC<Props> = (props) => {
  const { t } = useTranslation(['preorder', 'menu'])
  const history = useHistory()
  const location = useLocation()
  const [productInfo, setProductInfo] = useState<Product>(emptyProduct)
  const [productChanged, setProductChanged] = useState<boolean>(false)


  const changeCode = (newProductInfo: Product) => {
    newProductInfo.code = leadingZeros(newProductInfo.code)
    setProductInfo(newProductInfo)
    setProductChanged(true)
  }

  const PreorderProductCodeTextField = useMemo(() => entityTextField(changeCode),
    // eslint-disable-next-line
    [])

  const changePreorderProductCode = async (event: FormEvent) => {
    event.preventDefault()
    history.push({ search: filtersToSearch({ 'code': productInfo.code }), state: location.state })
    setProductInfo({ ...productInfo, code: '' });
  }

  const leadingZeros = (data: string) => `0000000${data}`.slice(-7)


  return <form onSubmit={changePreorderProductCode} style={{ marginLeft: '0px' }}>
    <Stack display="flex" flexDirection='row' justifyContent="center" alignItems="center" style={{ width: "160px", margin: '0px 0px' }}>
      <PreorderProductCodeTextField
        key="code"
        entity={productInfo}
        inputProps={{
          type: "tel",
          style: {
            textAlign: 'right',
            paddingRight: "55px"
          }
        }}
        attr="code"
        style={{ margin: '0px 20px' }}
        variant="outlined"
        label={t('code')}
      />
      <IconProgressButton style={{ marginLeft: '-35px' }} state={props.session} disabled={!productChanged}>
        <SearchOutlined />
      </IconProgressButton>
    </Stack>
  </form>

}


const mapStateToProps = (state: AppState) => ({
  session: state.session
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(PreorderProductCodeForm)


